import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  type SelectChangeEvent
} from "@mui/material";

interface DropdownProps {
  label: string;
  error?: boolean;
  helperText?: string;
  value: string | number;
  options: { label: string; value: string | number }[];
  onChange: (event: SelectChangeEvent<string | number>) => void;
  disabled?: boolean;
}

export const Dropdown = ({
  label,
  value,
  options,
  onChange,
  error = false,
  helperText = "",
  disabled,
}: DropdownProps) => {
  return (
    <FormControl fullWidth variant="standard" error={error}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label} disabled={disabled}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
